<template>
  <div class="container">
    <div v-if="loading">
      <div id="loader">
        <font-awesome-icon icon="spinner" spin />
      </div>
    </div>

    <h4 class="cardD">Accionistas</h4>

    <ValidationProvider
      name="Tipo de acciones"
      rules="required|oneOf:1,2"
      v-slot="{ errors }"
      :custom-messages="{ required: 'Seleccione una opción', oneOf: 'Seleccione una opción' }"
    >
      <div class="mb-4">
        <label for="radio-acciones-valor-nominal">Tipo de acciones</label>
        <b-form-radio-group
          id="radio-acciones-valor-nominal"
          v-model="constitutiva.acciones_valor_nominal"
          :disabled="constitutiva.disabledComplementa"
          name="acciones-valor-nominal"
        >
          <b-form-radio :value="1" class="d-block">Acciones sin expresión de valor nominal</b-form-radio>
          <b-form-radio :value="2" class="d-block">Acciones con valor nominal de $1.00 M.N., cada una</b-form-radio>
        </b-form-radio-group>

        <span class="cardErrors">{{ errors[0] }}</span>
      </div>
    </ValidationProvider>

    <label class="leyenda blue-text-important">Edita cada uno de los accionistas para llenar todos los datos necesarios.</label>
    <label class="leyenda blue-text-important">Serás enviado al apartado de comparecientes.</label>

    <div class="row">
      <div class="col-12">
        <label for="">Cuadro Accionario</label>
        <b-table hover :fields="fieldsCuadro" :items="constitutiva.accionistas">
          <!-- <template #cell(capital_variable)="{ item }">
            <b-input v-model="item.capital_variable" type="number"
              :disabled="constitutiva.tiene_capital_variable && constitutiva.disabledComplementa"></b-input>
          </template> -->
          <template #cell(porcentaje)="{ item }">
            {{ formatPercentage(item.porcentaje) }}
          </template>
          <template #cell(capital_fijo)="{ item }">
            {{ formatCurrency(item.capital_fijo) }}
          </template>
          <template #cell(acciones)="{ item }">
            <b-button
              variant="warning"
              size="sm"
              v-b-tooltip.hover
              title="Editar"
              class="editBtn"
              @click="editCompareciente(item)"
              :disabled="constitutiva.disabledComplementa"
            >
              <b-icon-pencil />
            </b-button>
          </template>
          <template #cell(listo)="{ item }">
            <div v-if="item.persona == 'Persona Moral'">
              <div v-if="item.rfc">
                <div class="circle completado_green" v-if="item.rfc.length === 12">
                  <span class="number"><i class="fa fa-check"></i></span>
                </div>
                <div class="circle completado_yellow" v-else>
                  <span class="number"><i class="fa fa-minus"></i></span>
                </div>
              </div>
              <div v-else>
                <div class="circle completado_yellow">
                  <span class="number"><i class="fa fa-minus"></i></span>
                </div>
              </div>
            </div>
            <div v-else-if="item.persona == 'Persona Física'">
              <div v-if="item.rfc">
                <div class="circle completado_green" v-if="item.rfc.length === 13">
                  <span class="number"><i class="fa fa-check"></i></span>
                </div>
                <div class="circle completado_yellow" v-else>
                  <span class="number"><i class="fa fa-minus"></i></span>
                </div>
              </div>
              <div v-else>
                <div class="circle completado_yellow">
                  <span class="number"><i class="fa fa-minus"></i></span>
                </div>
              </div>
            </div>
          </template>
        </b-table>

        <label for="check-clausula-extranjero">¿Tendrá cláusula de admisión de extranjeros?</label>
        <div v-if="constitutiva.capital_extranjero">
          <b-form-checkbox id="check-clausula-extranjero" v-model="constitutiva.clausula_extranjeros" disabled></b-form-checkbox>
        </div>
        <div v-else>
          <b-form-checkbox
            id="check-clausula-extranjero"
            v-model="constitutiva.clausula_extranjeros"
            :disabled="constitutiva.disabledComplementa"
          ></b-form-checkbox>
        </div>
      </div>
    </div>

    <div class="mt-4">
      <div v-if="constitutiva.disabledComplementa === false">
        <b-button type="submit" class="btn-fill orange-btn bottom2" size="m" :disabled="!canValidate">Continuar</b-button>
      </div>
      <div v-else>
        <b-button type="submit" class="btn-fill orange-btn bottom2" size="m" :disabled="constitutiva.disabledComplementa">
          Continuar
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import ModalOrganosAdministradores from "@/views/clients/procesos/constitucion/infoBase/modales/ModalOrganosAdministradores.vue";
import ModalOrganosVigilancia from "@/views/clients/procesos/constitucion/infoBase/modales/ModalOrganosVigilancia.vue";
import ModalApoderados from "@/views/clients/procesos/constitucion/infoBase/modales/ModalApoderados.vue";

import { formatCurrency, formatPercentage } from "@/utils/number-utils";

export default {
  name: "Accionistas",

  computed: {
    fieldsCuadro() {
      return [
        { key: "index", label: "", class: "text-center" },
        { key: "nombreCompleto", label: "Nombre", class: "text-center" },
        // { key: "paterno", label: "Paterno", class: "text-center" },
        // { key: "materno", label: "Materno", class: "text-center" },
        // { key: "email", label: "Email", class: "text-center" },
        { key: "rfc", label: "RFC", class: "text-center" },
        { key: "porcentaje", label: "Porcentaje", class: "text-center" },
        { key: "capital_fijo", label: "Capital Fijo", class: "text-center" },
        //{
        //  key: "capital_variable",
        //  label: "Capital Variable",
        //  class: "text-center",
        //  thStyle: { width: '150px' },
        //  tdStyle: { width: '150px' }
        //},
        { key: "acciones", label: "Acciones", class: "text-center" },
        { key: "listo", label: "", class: "text-center" },
      ];
    },
  },

  created() {
    this.calcularCapitales();
    this.clausula();
    this.enableSave();
  },

  watch: {
    "constitutiva.accionistas": {
      handler: function (val, oldVal) {
        this.enableSave();
      },
      deep: true,
    },
  },

  components: {
    ModalOrganosAdministradores,
    ModalOrganosVigilancia,
    ModalApoderados,
  },

  props: {
    constitutiva: { type: Object },
  },

  data() {
    return {
      loading: false,
      canValidate: false,

      totalPorcentajes: 0,
    };
  },

  methods: {
    formatCurrency,
    formatPercentage,

    enableSave() {
      const invalidCount = this.constitutiva.accionistas.filter(({ rfc, persona }) => {
        if (!rfc) return true;
        if (persona === "Persona Moral" && rfc.length !== 12) return true;
        if (persona === "Persona Física" && rfc.length !== 13) return true;
        return false;
      }).length;

      this.canValidate = invalidCount === 0;
    },

    clausula() {
      if (this.constitutiva.capital_extranjero === 1 || this.constitutiva.capital_extranjero === true) {
        this.constitutiva.clausula_extranjeros = true;
      } else if (this.constitutiva.clausula_extranjeros === true || this.constitutiva.clausula_extranjeros === 1) {
        this.constitutiva.clausula_extranjeros = true;
      } else {
        this.constitutiva.clausula_extranjeros = false;
      }
    },

    calcularCapitales() {
      // let totalPorcentajes = 0;

      this.constitutiva.accionistas.forEach((accionista) => {
        const porcentaje = parseFloat(accionista.porcentaje) || 0;
        const capital_fijo = (porcentaje * this.constitutiva.capital_fijo) / 100;

        // totalPorcentajes += porcentaje;
        this.$set(accionista, "capital_fijo", capital_fijo);
      });

      // this.totalPorcentajes = totalPorcentajes;
    },

    editCompareciente(item) {
      this.$router.push({
        name: "EditComparecientes",
        params: { id: item.id },
        query: {
          proceso: 1,
          procesoAccion: "addconstitucion",
          procesoId: this.constitutiva.id,
          accion: "edit",
        },
      });
      //mandar con alguna bandera para que regrese al consti_id y node completa_info
    },
  },
};
</script>

<style scoped>
.completado_green {
  background-color: yellowgreen !important;
}

.completado_yellow {
  background-color: gold !important;
}
</style>
